var map = {
	"./icon-coupon-active.svg": "92b5",
	"./icon-coupon.svg": "9c76",
	"./icon-heart-active.svg": "af77",
	"./icon-heart.svg": "d83c",
	"./icon-language-white.svg": "57d1",
	"./icon-language.svg": "599e",
	"./icon-order-active.svg": "782b",
	"./icon-order.svg": "eb95",
	"./icon-premium-active.svg": "65b3",
	"./icon-premium.svg": "4225",
	"./icon-user-active.svg": "c356",
	"./icon-user.svg": "eaa8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e46";